import styled from '@emotion/styled'

/** 컨베이어 하단 경계에 EnergyBadge가 걸치도록 위로 올림 */
const OVERLAP_PX = 143

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-top: -${OVERLAP_PX}px;
  z-index: 2;
`
